var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNotice)?_c('div',{staticClass:"notice"},[_c('div',{staticClass:"notice-content",style:(_vm.style)},[_vm._t("default")],2),(_vm.closeBtn)?_c('img',{staticClass:"notice-close",attrs:{"src":require("../assets/icons/notice-close.png"),"alt":""},on:{"click":_vm.close}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }